import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
const changeStatusMutation = gql`mutation update_supplier_orders(
  $id:uuid!,
  $supplies_orders: supplies_orders_set_input!,
  $supplies_order_notes: supplies_order_notes_insert_input!
){
  update_supplies_orders_by_pk(pk_columns:{id:$id}, _set: $supplies_orders){
    id
  }
  insert_supplies_order_notes_one(object: $supplies_order_notes){
    id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class ChangeStatusService {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
/* ------------------------------ Change Status ----------------------------- */
  changeStatus(
    id: string,
    supplies_orders: any,
    supplies_order_notes: any
  ): Promise<any> {
    return this.apollo.use('external').mutate({
      mutation: changeStatusMutation,
      variables:{
        id,
        supplies_orders,
        supplies_order_notes
      }
    }).toPromise()
  }
}
